import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  idle_time_total: '0',
  ideal_time_check: false,
  customerID: ''
}

export const idleTimeLock = createSlice({
  name: 'idle_time',
  initialState,
  reducers: {
    setIdleTime: (state, action) => {
      Object.assign(state, action.payload)
    },
    initializeIdleTime: () => initialState,
    setIdleTimeTotal: (state, action) => {
      state.idle_time_total = action.payload
    }
  }
})

export const { setIdleTime, initializeIdleTime, setIdleTimeTotal } =
  idleTimeLock.actions

export default idleTimeLock.reducer
